// SAD-482 PUR-02: TanStack Query bindings for the typed Pursuit team. The
// CaptureTeamService is served by zou through sabaody; the tenant and caller
// come from the gateway principal, never from the request.
import { Code, ConnectError, createClient } from '@connectrpc/connect';
import { CaptureTeamService } from '@mono/proto-clients';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { connectTransport } from '../../lib/connect/transport';
import { CAPTURE_KEY } from './hooks';
const captureTeamClient = createClient(CaptureTeamService, connectTransport);
const TEAM_KEY = 'capture-team';
export function isPermissionDenied(err) {
    return err instanceof ConnectError && err.code === Code.PermissionDenied;
}
export function useCaptureTeam(captureProjectId) {
    return useQuery({
        queryKey: [
            TEAM_KEY,
            captureProjectId
        ],
        enabled: captureProjectId !== '',
        retry: (count, err)=>!isPermissionDenied(err) && count < 2,
        queryFn: async ()=>(await captureTeamClient.listCaptureTeam({
                captureProjectId
            })).members
    });
}
function useTeamMutation(captureProjectId, call, alsoInvalidate) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: call,
        onSuccess: ()=>{
            alsoInvalidate?.();
            return queryClient.invalidateQueries({
                queryKey: [
                    TEAM_KEY,
                    captureProjectId
                ]
            });
        }
    });
}
export function useAddNamedContributor(captureProjectId) {
    return useTeamMutation(captureProjectId, (a)=>captureTeamClient.addNamedContributor({
            captureProjectId,
            ...a
        }));
}
export function useRemoveCaptureTeamMember(captureProjectId) {
    return useTeamMutation(captureProjectId, (memberId)=>captureTeamClient.removeCaptureTeamMember({
            captureProjectId,
            memberId
        }));
}
export function useSetCaptureTeamOwner(captureProjectId) {
    const queryClient = useQueryClient();
    return useTeamMutation(captureProjectId, (userId)=>captureTeamClient.setCaptureTeamOwner({
            captureProjectId,
            userId
        }), // zou moves the profile's capture_manager_id with the owner, so the
    // profile panel must refetch or its next save would send the stale manager.
    ()=>queryClient.invalidateQueries({
            queryKey: [
                CAPTURE_KEY,
                captureProjectId
            ]
        }));
}
